import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { inboxViewInit } from '../inboxViewSlice';
import { RootState } from '../../../../store';
import { routingOnRouteToInbox } from 'src/app/store/routingSlice';

type IN = ReturnType<typeof routingOnRouteToInbox>;
type OUT = ReturnType<typeof inboxViewInit>;

export const InboxViewOnRouteEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(routingOnRouteToInbox.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return [inboxViewInit()];
    }),
  );
